var map = {
	"./all_of_me_pluspunkt.mp3": 183,
	"./bergwerk_pluspunkt.mp3": 184,
	"./billie_jean_pluspunkt.mp3": 185,
	"./i_need_a_dollar_pluspunkt.mp3": 186,
	"./jailhouse_rock_pluspunkt.mp3": 187,
	"./jolene_pluspunkt.mp3": 188,
	"./teenage_dirtbag_pluspunkt.mp3": 189
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 182;


//////////////////
// WEBPACK FOOTER
// ./src/snippets nonrecursive \.(mp3)$
// module id = 182
// module chunks = 0